import React, { Component } from 'react';
import {
  Grid, Row, Col,
} from 'react-bootstrap';
import { Link } from 'react-router';

/** CUSTOM COMPONENTS **/
import { BoxTopContent } from './../../components/Site/BoxTopContent/BoxTopContent';
import { BoxProductsContent } from './../../components/Site/BoxProductsContent/BoxProductsContent';
export class Site_HomeContainer extends Component{
  render(){
    return (
      <Col xs={12} md={12} className={'no-padding'}>
        <BoxTopContent />
        <BoxProductsContent />
        <Col md={12} className={'text-center'}>
          <div className="fb-page" data-href="https://www.facebook.com/tchauvarallavanderia/" data-tabs="timeline" data-width="600" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/tchauvarallavanderia/" className="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/tchauvarallavanderia/">Tchau Varal Lavanderia</a></blockquote></div>
        </Col>
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Site/Site_HomeContainer.js